import { render, staticRenderFns } from "./coldChainRecord.vue?vue&type=template&id=0a2c6d42&scoped=true"
import script from "./coldChainRecord.vue?vue&type=script&lang=js"
export * from "./coldChainRecord.vue?vue&type=script&lang=js"
import style0 from "./coldChainRecord.vue?vue&type=style&index=0&id=0a2c6d42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2c6d42",
  null
  
)

export default component.exports